/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { Grid, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { IErrorProps } from "../../models";
import GetToastErrorMessages from "./GetToastErrorMeessages";
import ToastBarForError from "./ToastBarForError";
import DialogForError from "./DialogForError";
import { error } from "console";

interface CombineErrorProps {
  openToast: boolean;
  onCloseToast(): void;
  errorList: Array<IErrorProps>;
  ///ToastError
  openServerError: boolean;
  onCloseServerError(): void;
  //ServerError
  openNoURL: boolean;
  onCloseNoURL(): void;
  //NoURLFoundError
  openDialogforConflict: boolean;
  onCloseServerConflictError(): void;

  //dialog for conflict
}

export default function ErrorHandlingComponent(props: CombineErrorProps) {
  return (
    <>
      <ToastBarForError
        open={props.openToast}
        onClose={props.onCloseToast}
        errorList={props.errorList}
      />
      <DialogForError
        open={props.openServerError}
        errorType="serverError"
        onClose={props.onCloseServerError}
        errorList={props.errorList}
      />
      <DialogForError
        open={props.openNoURL}
        onClose={props.onCloseNoURL}
        errorList={props.errorList}
        errorType="noURLFoundError"
      ></DialogForError>
      <DialogForError
        open={props.openDialogforConflict}
        onClose={props.onCloseServerConflictError}
        errorList={props.errorList}
        errorType="conflictError"
      />
    </>
  );
}
